// JobTemplateTab.tsx
import React from "react";
import { SpinnerCircular } from "spinners-react";
import ReactQuill from "react-quill";
import { CardBody } from "../../../components/bootstrap/Card";
import Label from '../../../components/bootstrap/forms/Label';

interface JobTemplateTabProps {
    loading: boolean;
    // eslint-disable-next-line react/require-default-props
    requirement?: { jdContent?: string };
    darkModeStatus: boolean;
}

const JobTemplateTab: React.FC<JobTemplateTabProps> = ({ loading, requirement, darkModeStatus }) => {
    if (loading) {
        return (
            <CardBody className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                <SpinnerCircular
                    size={50}
                    thickness={100}
                    speed={100}
                    color={darkModeStatus ? "#fff" : "#4ecdc4"}
                    secondaryColor={darkModeStatus ? "#4ecdc4" : "#f1f1f1"}
                />
            </CardBody>
        );
    }

    if (requirement?.jdContent) {
        return (
            <CardBody className="d-flex flex-column">
                <Label htmlFor="text-editor">Text Editor</Label>
                <div
                    className="p-3 border rounded bg-dark mb-3"
                    style={{ maxHeight: "400px", overflow: "scroll" }}
                >
                    <ReactQuill
                        readOnly
                        className="text-light bg-dark"
                        theme="snow"
                        modules={{ toolbar: false }}
                        value={requirement.jdContent}
                        style={{
                            minHeight: "50px",
                            fontSize: "1rem",
                            color: "#343a40",
                            cursor: "pointer",
                        }}
                    />
                </div>
            </CardBody>
        );
    }

    return <CardBody className="text-center">No Template Found</CardBody>;
};

export default JobTemplateTab;
